export type SupportedLocales = {
  defaultLocale: string;
  locales: Array<string>;
};

export const fetchSupportedLocales = async (): Promise<SupportedLocales> => {
  const response = await fetch(`/api/contentful/locales`);
  const { default: defaultLocale, locales } = await response.json();
  return {
    defaultLocale,
    locales,
  };
};
